import { useEffect, useState } from "react";
import constate from "constate";

import { getAuthConfig } from "../../api/services";
import { verifyAuthConfig, AuthConfig } from "../../api/OAuth2Client";
import { useSessionStorage } from "../../hooks";

const useConfig = () => {
  const [authConfig, setAuthConfig] = useSessionStorage<AuthConfig | null>(
    "App.AuthConfig",
    null,
  );
  const [error, setError] = useState<Error | null>(null);
  const [loading, setLoading] = useState(!authConfig);

  useEffect(() => {
    if (!error && !authConfig) {
      getAuthConfig()
        .then((data: any) => {
          setAuthConfig(verifyAuthConfig(data));
        })
        .catch(setError)
        .then(() => setLoading(false));
    }
  }, [authConfig, error, setAuthConfig, setError]);
  return {
    error,
    authConfig,
    loading,
  };
};

export const [ConfigProvider, useConfigContext] = constate(useConfig);
